import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    FC,
} from 'react';
import {
    useLocation,
} from 'react-router-dom';

import {
    useIsMobile,
} from 'helpers/adaptive';

import {
    useNewAccountDraftsCount,
} from 'entities/accountDrafts/hooks/use-new-account-drafts-count';
import {
    PERMISSION,
    ROLE,
} from 'entities/users/constants';
import {
    hasPermissionOrAdmin,
    hasPermissionsOrAdmin,
} from 'entities/users/functions';
import {
    useUserByMe,
} from 'entities/users/hooks';

import {
    PATH,
} from 'pages/constants';

import NavItem from './NavItem';

import styles from './Navigation.module.scss';

const Navigation: FC<IProps> = (props) => {
    const {authUser} = useUserByMe();
    const {newAccountDraftsCount} = useNewAccountDraftsCount();

    const location = useLocation();

    const isMobile = useIsMobile();

    return (
        <nav
            className={classNames(styles.navigation, props.className)}
            onClick={props.onClick}
        >
            {
                authUser &&
                <>
                    <NavItem
                        text={'Payments'}
                        isActive={
                            location.pathname.startsWith(PATH.PAYMENT) &&
                            !location.pathname.startsWith(PATH.PAYMENT_METHOD)
                        }
                        isShown={hasPermissionOrAdmin(authUser, PERMISSION.PAYMENTS_VIEW)}
                        to={PATH.PAYMENTS}
                    />
                    <NavItem
                        text={'Complaints'}
                        isActive={location.pathname.startsWith(PATH.COMPLAINT)}
                        isShown={hasPermissionOrAdmin(authUser, PERMISSION.COMPLAINTS_VIEW)}
                        to={PATH.COMPLAINTS}
                    />
                    <NavItem
                        text={'Accounts'}
                        isActive={
                            location.pathname.startsWith(PATH.ACCOUNT) &&
                            !location.pathname.startsWith(PATH.ACCOUNT_POOL) &&
                            !location.pathname.startsWith(PATH.ACCOUNT_DRAFTS)
                        }
                        isShown={hasPermissionOrAdmin(authUser, PERMISSION.ACCOUNTS_VIEW)}
                        to={PATH.ACCOUNTS}
                    />
                    <NavItem
                        text={'Account drafts'}
                        isActive={location.pathname.startsWith(PATH.ACCOUNT_DRAFTS)}
                        isShown={
                            hasPermissionsOrAdmin(authUser, [
                                PERMISSION.ACCOUNT_DRAFTS_MANAGE,
                                PERMISSION.ACCOUNT_DRAFTS_REVIEW,
                            ])
                        }
                        to={PATH.ACCOUNT_DRAFTS}
                        count={newAccountDraftsCount}
                    />
                    <NavItem
                        text={'Account pools'}
                        isActive={location.pathname.startsWith(PATH.ACCOUNT_POOL)}
                        isShown={hasPermissionOrAdmin(authUser, PERMISSION.ACCOUNT_POOLS_VIEW)}
                        to={PATH.ACCOUNT_POOLS}
                    />
                    <NavItem
                        text={'Agents'}
                        isActive={location.pathname.startsWith(PATH.AGENT)}
                        isShown={hasPermissionOrAdmin(authUser, PERMISSION.AGENTS_VIEW)}
                        to={PATH.AGENTS}
                    />
                    <NavItem
                        text={'Payment methods'}
                        isActive={location.pathname.startsWith(PATH.PAYMENT_METHOD)}
                        isShown={
                            hasPermissionOrAdmin(authUser, PERMISSION.PAYMENT_METHODS_VIEW) &&
                            isMobile
                        }
                        to={PATH.PAYMENT_METHODS}
                    />
                    <NavItem
                        text={'Merchants'}
                        isActive={location.pathname.startsWith(PATH.MERCHANT)}
                        isShown={hasPermissionOrAdmin(authUser, PERMISSION.MERCHANTS_VIEW)}
                        to={PATH.MERCHANTS}
                    />
                    <NavItem
                        text={'Transactions'}
                        isActive={location.pathname.startsWith(PATH.TRANSACTIONS)}
                        isShown={hasPermissionOrAdmin(authUser, PERMISSION.TRANSACTIONS_VIEW)}
                        to={PATH.TRANSACTIONS}
                    />
                    <NavItem
                        text={'Proxies'}
                        isActive={
                            location.pathname.startsWith(PATH.PROXY) ||
                            location.pathname.startsWith(PATH.PROXIES)
                        }
                        isShown={
                            hasPermissionOrAdmin(authUser, PERMISSION.PROXIES_VIEW) &&
                            isMobile
                        }
                        to={PATH.PROXIES}
                    />
                    <NavItem
                        text={'Agent statistics'}
                        isActive={location.pathname.startsWith(PATH.STATISTICS_AGENT)}
                        isShown={
                            hasPermissionOrAdmin(authUser, PERMISSION.AGENTS_STATISTICS_VIEW) &&
                            isMobile
                        }
                        to={PATH.STATISTICS_AGENT}
                    />
                    <NavItem
                        text={'Users'}
                        isActive={location.pathname.startsWith(PATH.USER)}
                        isShown={
                            authUser?.role === ROLE.SUPER_ADMIN &&
                            isMobile
                        }
                        to={PATH.USERS}
                    />
                    <NavItem
                        text={'Admin'}
                        isActive={location.pathname.startsWith(PATH.ADMIN_PANEL)}
                        isShown={
                            hasPermissionsOrAdmin(authUser, [
                                PERMISSION.SETTINGS_CONVERSION_VIEW,
                                PERMISSION.SETTINGS_PREPAY_VIEW,
                                PERMISSION.SETTINGS_ANTI_FRAUD_VIEW,
                            ]) &&
                            isMobile
                        }
                        to={PATH.ADMIN_PANEL}
                    />
                </>
            }
        </nav>
    );
};

export default Navigation;
